// The signed-in user's swiper rights and quotas (Animation Settings ->
// Swiper Access & Limits), for the UI only: every action is re-checked by
// the server, whatever this says.
import { useEffect, useState } from "react";
import { getSwiperAccess } from "../auth/apiDynamicSwipers";
import { getRoleContext } from "../pageInside/Rolle";

export const canAccessSwiperManager = (access) => access?.permissions?.create === true;

export const useSwiperAccess = (infoSource) => {
  const [state, setState] = useState({ loading: true, access: null });
  const effectiveRole = getRoleContext(infoSource).effectiveRole || "";
  const load = async (refresh = false) => {
    setState((prev) => ({ ...prev, loading: true }));
    const access = await getSwiperAccess({ refresh, roleKey: effectiveRole });
    setState({ loading: false, access });
    return access;
  };
  useEffect(() => {
    let active = true;
    setState({ loading: true, access: null });
    getSwiperAccess({ refresh: false, roleKey: effectiveRole }).then((access) => {
      if (active) setState({ loading: false, access });
    });
    return () => { active = false; };
  }, [effectiveRole]);
  return { ...state, reload: () => load(true) };
};

export default useSwiperAccess;
